module.exports = __webpack_public_path__ + "img/M1.037707a9.png";